import React from "react";
import styles from "./Loading.module.scss";

const LoadingSpinner = () => {
  return <i className={styles["loading-spinner"]}></i>;
};

export default LoadingSpinner;
